import { ArticleBlock } from '../types/article'
import { storyPartOne } from './storyPartOne'
import { storyPartTwo } from './storyPartTwo'

export const PRODUCT_URL = 'https://rylte.com/products/ryltes-gps-wireless-dog-fence'

export const articleMeta = {
  kicker: 'Real Owner Stories',
  title:
    "I Spent Two Years Trying to Stop My Husky From Escaping. Here's What Stopped Him in Three Days.",
  standfirst:
    'No fence. No buried wires. No monthly subscription. Just a boundary he learned to respect.',
  author: 'Megan Rutherford',
  location: 'Boise, Idaho',
  date: 'Updated August 24, 2026',
  readTime: '9 min read',
  heroVideo:
    'https://cdn.magicpatterns.com/uploads/p5pCh1t2FpW51BiP42BbTy/hf_20260826_155851_47f8adbe-ea52-4430-96a0-69bf29d6c8f5.mp4',
}

export const articleBlocks: ArticleBlock[] = [...storyPartOne, ...storyPartTwo]
